import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const [jtoken, setJToken] = useState(() => localStorage.getItem('jtoken') || null);

    // Sync localStorage when the token changes
    useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        } else {
            localStorage.removeItem('token');
        }
    }, [token]);

    useEffect(() => {
        if (jtoken) {
            localStorage.setItem('jtoken', jtoken);
        } else {
            localStorage.removeItem('jtoken');
        }
    }, [jtoken]);

    const login = (a, b) => { setToken(b); setJToken(a) };
    const logout = () => { setToken(null); setJToken(null) };

    return (
        <AuthContext.Provider value={{ token, jtoken, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
